import {SetAccessAdministrationUserPermissionOverrideBody} from "@project/sdk/access-administration/zod";
import type {z} from "zod";

export const setPermissionOverrideFormSchema = SetAccessAdministrationUserPermissionOverrideBody;
export type SetPermissionOverrideFormPayload = z.output<typeof setPermissionOverrideFormSchema>;
export const draftSetPermissionOverrideFormSchema = setPermissionOverrideFormSchema.partial();
export type DraftSetPermissionOverrideFormPayload = z.output<
  typeof draftSetPermissionOverrideFormSchema
>;
